import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { ArrowDirection, ArrowIconWithMargin, ProgressBar } from '../atoms';
export const GoalMatchingAssessmentHeader = ({ classObject, onClickBack, progressQuestionCount, prgoressCurrent, hideProgress, }) => {
    return (React.createElement("div", { className: css(styles.header, classObject) },
        React.createElement(ArrowIconWithMargin, { onClick: onClickBack, direction: ArrowDirection.left, color: Colors.TextDark, classObject: styles.fixedBackButton }),
        !hideProgress && (React.createElement("div", { className: css(styles.progressBarBox) },
            React.createElement(ProgressBar, { classObject: styles.progressBar, max: progressQuestionCount, current: prgoressCurrent, color: Colors.PrimaryDark, trackColor: Colors.BackgroundBlue })))));
};
const styles = StyleSheet.create({
    header: {
        display: 'flex',
        alignItems: 'center',
        height: 32,
        marginBottom: 30,
        position: 'relative',
        width: '100%',
    },
    fixedBackButton: {
        width: 24,
        height: 24,
        [MediaBreakPointUp.MD]: {
            position: 'fixed',
            top: 16,
            left: 16,
            width: 32,
            height: 32,
        },
    },
    progressBarBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        marginRight: 14,
        [MediaBreakPointUp.MD]: {
            position: 'absolute',
            bottom: -80,
        },
    },
    progressBar: {
        width: 173,
    },
});
